// src/components/FavoritesPage.js
import React, { useEffect, useState } from "react";
import { fetchFavorites } from "../api/favoritesApi";
import AdCard from "./AdCard";
import BackLink from "./BackLink";
import "./FavoritesPage.css";
import AdCardSkeleton from "./AdCardSkeleton";

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    async function loadFavorites() {
      try {
        setLoading(true);
        setError("");

        const data = await fetchFavorites();
        if (!isMounted) return;

        setFavorites(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Σφάλμα φόρτωσης αγαπημένων:", e);
        if (isMounted) {
          setError("Σφάλμα φόρτωσης αγαπημένων αγγελιών.");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    loadFavorites();
    return () => (isMounted = false);
  }, []);

  return (
    <div className="favorites-page">

      {/* 🔙 Стрелка назад */}
      <BackLink label="Πίσω" />

      {loading && (
        <>
          <h1 className="fav-title">Τα αγαπημένα μου</h1>

          <div className="ads-grid fav-grid">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <AdCardSkeleton key={i} />
            ))}
          </div>
        </>
      )}

      {error && <div className="fav-error">{error}</div>}

      {!loading && !error && favorites.length === 0 && (
        <div>
          <h1 className="fav-title">Τα αγαπημένα μου</h1>
          <p className="fav-empty">Δεν έχετε αγαπημένες αγγελίες ακόμη.</p>
        </div>
      )}

      {!loading && !error && favorites.length > 0 && (
        <>
          <h1 className="fav-title">Τα αγαπημένα μου</h1>

          <div className="ads-grid fav-grid">
            {favorites.map((ad) => (
              <AdCard key={ad.id} ad={ad} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default FavoritesPage;
